module.exports = __webpack_public_path__ + "img/tw.684e8349.svg";